/**
 * /me/attendance/today — Session 3d PR 19.
 * Owning agent: Khidmat. Detail-card-style page (NOT a list).
 */

import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { ErrorPanel, Loading } from "../components/Loading";
import { session3dApi } from "../lib/session3d-api";
import {
  MeActionsRow,
  MeEmployeeRequiredGate,
  Session3dMeShell,
  useCurrentEmployeeId,
} from "./_session3dShell";

export function MyAttendanceTodayPage() {
  const { t } = useTranslation();
  const employeeId = useCurrentEmployeeId();

  const query = useQuery({
    queryKey: ["s3d-attendance-today", employeeId],
    queryFn: () => session3dApi.getAttendanceToday(employeeId),
    enabled: !!employeeId,
  });

  const data = query.data;

  return (
    <MeEmployeeRequiredGate>
      <Session3dMeShell
        title={t("me.attendance-today.title", "Today's Status")}
        subtitle={t("me.attendance-today.subtitle", "Real-time today view — clocked in · shift · on time.")}
        briefContext={{
          total: 1,
          attention: 0,
          critical: 0,
          top_kind: t("me.attendance-today.title", "Today's Status"),
          window_label: t("me.attendance-today.window", "today"),
        }}
        actionsRow={
          <MeActionsRow
            khidmatPrefill={t("me.attendance-today.ask_khidmat", "What's my attendance status right now?")}
          />
        }
      >
        {query.isLoading && <Loading />}
        {query.isError && <ErrorPanel message={(query.error as Error).message} />}
        {data && (
          <div className="rounded-2xl border border-border-subtle bg-white p-4 text-sm">
            <p className="text-xs text-text-tertiary">
              {t(
                "me.attendance-today.detail_note",
                "Current status: clocked in · shift · late minutes. Clock In / Clock Out actions wire in when biometric integration ships.",
              )}
            </p>
            <pre className="mt-3 overflow-x-auto rounded bg-surface-sunken p-3 font-mono text-[10px] text-text-secondary">
{JSON.stringify(data, null, 2)}
            </pre>
          </div>
        )}
      </Session3dMeShell>
    </MeEmployeeRequiredGate>
  );
}
